import React, { Fragment, useEffect, useState } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Spin from '../../../components/loading';
import Map from '../../../components/map';
import ENUMS from '../../../enums';
import ShowForPermission from '../../../components/ShowForPermission';
import { enumHelper, formatter } from '../../../utils';
import * as cafeActions from '../../../redux/cafes/actions';
import './styles.scss';
import pdfIcon from '../../../assets/icons/pdficon.png';

const renderIconName = name => {
  switch (name) {
    case ENUMS.CONTACT_TYPES.values.EMAIL:
      return 'fal fa-envelope-open';
    case ENUMS.CONTACT_TYPES.values.INSTAGRAM:
      return 'fab fa-instagram';
    case ENUMS.CONTACT_TYPES.values.WEBSITE:
      return 'fal fa-browser';
    case ENUMS.CONTACT_TYPES.values.PHONE:
      return 'fal fa-phone';
    case ENUMS.CONTACT_TYPES.values.MOBILE:
      return 'fal fa-mobile-alt';
    default:
      break;
  }
};

const MyCafeInfo = props => {
  useEffect(() => {
    props.getCafeByIdForAdmin();
  }, []);

  const {
    cafeByIdForAdminLoading,
    cafeByIdForAdminError,
    cafeByIdForAdminFailed,
    cafeByIdForAdminMessage,
    cafeByIdForAdmin,
  } = props;

  let {
    id,
    name,
    status,
    logoUrl,
    locationTableUrl,
    menuUrl,
    latitude,
    longitude,
    address,
    description,
    rseePercent,
    ownerFullName,
    cafeImages,
    manHourPrepaidPrice,
    meals,
    currency,
    regions,
    regionIds,
    amenityIds,
    amenities,
    specialServiceIds,
    specialServices,
    contacts,
    workingHours = [],
    tables,
    timeInterval
  } = cafeByIdForAdmin;
  let temp = [];
  for (let j = 0; j < ENUMS.WEEK_DAYS.list.length; j++) {
    for (let i = 0; i < workingHours.length; i++) {
      if (workingHours[i].day == ENUMS.WEEK_DAYS.list[j].value) {
        temp.push(workingHours[i]);
      }
    }
  }
  workingHours = [
    ...temp.sort(
      (a, b) => a.day == b.day && a.fromTime.localeCompare(b.fromTime),
    ),
  ];
  return (
    <Fragment>
      <Spin spinning={cafeByIdForAdminLoading}>
        {cafeByIdForAdminError && (
          <div className='alert alert-danger'>
            {locales('messages.server.error')}
          </div>
        )}
        {cafeByIdForAdminFailed && (
          <div className='alert alert-danger'>{cafeByIdForAdminMessage}</div>
        )}

        <section className='page-header'>
          <div className='col-12 d-flex justify-content-between align-items-center'>
            <h3>{locales('titles.my.cafe.info')}</h3>
          </div>
        </section>

        <section className='panel panel-default'>
          <div className='panel-heading'>
            <h3 className='panel-title'>
              <i className='fa fa-pencil'></i>
              {locales('titles.editCafeData', { fieldName: name })}
            </h3>
          </div>
          <div className='panel-body'>
            <div className='d-flex m-2'>
              <div className='col-lg-4 col-md-12 col-sm-12 d-flex'>
                <label htmlFor='name' className='rsee-form-label col-3 text-right'>
                  {locales('fields.cafe.name')}
                </label>
                <span
                  name='name'
                  id='name'
                  className='text-dark font-weigth-bold font-large full-width'
                >
                  {name || '---'}
                </span>
              </div>

              <div className='col-lg-4 col-md-12 col-sm-12 d-flex'>
                <label htmlFor='ownerFullName' className='rsee-form-label col-3 text-right'>
                  {locales('fields.cafe.owner.full.name')}
                </label>
                <span
                  name='ownerFullName'
                  id='ownerFullName'
                  className='text-dark font-weigth-bold font-large full-width'
                >
                  {ownerFullName || '---'}
                </span>
              </div>

              <div className='col-lg-4 col-md-12 col-sm-12 d-flex'>
                <label htmlFor='rseePercent' className='rsee-form-label col-5 text-right'>
                  {locales('fields.rsee.percent')}
                </label>
                <span
                  name='rseePercent'
                  id='rseePercent'
                  className='text-dark font-weigth-bold font-large full-width'
                >
                  {rseePercent || '---'}
                </span>
              </div>
            </div>

            <div className='d-flex m-2'>
              <div className='col-lg-4 col-md-12 col-sm-12 '>
                <label htmlFor='description' className='rsee-form-label col-3 text-right'>
                  {locales('messages.description')}
                </label>
                <span
                  name='description'
                  id='description'
                  className='text-dark font-weigth-bold font-large full-width'
                >
                  {description || '---'}
                </span>
              </div>

              <div className='col-lg-4 col-md-12 col-sm-12'>
                <label className='rsee-form-label col-5 text-right' htmlFor='cities'>
                  {locales('the.duration.of.each.reservation')}
                </label>
                <span
                  id='timeInterval'
                  name='timeInterval'
                  className='text-dark font-weigth-bold font-large full-width'
                >
                  {ENUMS.RESERVE_DURATION.list?.map(time => (time.value === timeInterval && time.title))}
                </span>
              </div>
            </div>

            <div className='d-flex justify-content-between flex-wrap border-top'>
              <div className='my-4'>
                <label htmlFor='address' className='rsee-form-label pl-3'>
                  {locales('messages.address')}
                </label>
                <span
                  name='addressame'
                  id='address'
                  className='text-dark font-weigth-bold font-large my-2'
                >
                  {address || '---'}
                </span>
              </div>

              <div id='map-container'>
                <Map
                  latitude={latitude ? latitude : 0}
                  longitude={longitude ? longitude : 0}
                  disabled={true}
                />
              </div>

              <div className='my-3'>
                <label htmlFor='regions' className='rsee-form-label pl-3'>
                  {locales('messages.regions')}
                </label>
                <span
                  name='regions'
                  id='regions'
                  className='text-dark font-weigth-bold font-large my-2'
                >
                  {regions && regions.length
                    ? regions.map((region, index, self) => (
                      <span className='mx-2' key={index}>
                        {region.name} {index < self.length - 1 ? '،' : ''}
                      </span>
                    ))
                    : '---'}
                </span>
              </div>
            </div>

            <div className='d-flex col-12 justify-content-between flex-wrap border-top'>
              <div className='col-6'>
                <label
                  htmlFor='workingHours'
                  className='col-12 text-center font-weigth-bold font-large my-2'
                >
                  {locales('messages.workingHours')}
                </label>
                <table className='table table-striped table-light table-hover'>
                  <thead>
                    <tr>
                      <th className='text-center'>{locales('tables.row')}</th>
                      <th className='text-center'>
                        {locales('labels.weekday')}
                      </th>
                      <th className='text-center'>
                        {locales('fields.start.time')}
                      </th>
                      <th className='text-center'>
                        {locales('fields.end.time')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {workingHours &&
                      workingHours.length &&
                      workingHours.map((workingHour, index) => (
                        <tr key={workingHour.id}>
                          <td className='text-center'>{index + 1}</td>
                          <td className='text-center'>
                            {enumHelper.convertEnumValueToTitle(
                              ENUMS.WEEK_DAYS.list,
                              workingHour.day,
                            )}
                          </td>
                          <td className='text-center'>
                            {workingHour.fromTime}
                          </td>
                          <td className='text-center'>{workingHour.toTime}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <div className='col-6'>
                <label
                  htmlFor='contacts'
                  className='col-12 text-center font-weigth-bold font-large my-2'
                >
                  {locales('titles.contact.items')}
                </label>
                <table className='table table-striped table-light table-hover'>
                  <thead>
                    <tr>
                      <th className='text-center'>{locales('tables.row')}</th>
                      <th className='text-center'>
                        {locales('fields.contact.type')}
                      </th>
                      <th className='text-center'>
                        {locales('fields.contact.value')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {contacts &&
                      contacts.length &&
                      contacts.map((contact, index) => (
                        <tr key={contact.id}>
                          <td className='text-center'>{index + 1}</td>
                          <td className='text-center'>
                            <i
                              className={`${renderIconName(contact.type)} px-1`}
                            />
                          </td>
                          <td className='text-center'>{contact.value}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className='d-flex justify-content-between flex-wrap border-top'>
              <div className='col-12'>
                <label
                  htmlFor='tables'
                  className='col-12 text-center font-weigth-bold font-large my-2'
                >
                  {locales('fields.tables')}
                </label>
                <table className='table table-striped table-light table-hover'>
                  <thead>
                    <tr>
                      <th className='text-center'>{locales('tables.row')}</th>
                      <th className='text-center'>
                        {locales('tables.tableNumber')}
                      </th>
                      <th className='text-center'>{locales('table.title')}</th>
                      <th className='text-center'>{locales('fields.floor')}</th>
                      <th className='text-center'>{locales('fields.area')}</th>
                      <th className='text-center'>
                        {locales('fields.table.numberOfChairs')}
                      </th>
                      <th className='text-center'>
                        {locales('tables.isSmoking')}
                      </th>
                      <th className='text-center'>
                        {locales('fields.heatSystem')}
                      </th>
                      <th className='text-center'>
                        {locales('fields.coolingSystem')}
                      </th>
                      <th className='text-center'>
                        {locales('fields.fogCoolingSystem')}
                      </th>
                      <th className='text-center'>{locales('inputAmount')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tables &&
                      tables.length &&
                      tables.map((table, index) => (
                        <tr key={table.id}>
                          <td className='text-center'>{index + 1}</td>
                          <td className='text-center'>{table.num}</td>
                          <td className='text-center'>{table.tableTitle}</td>
                          <td className='text-center'>
                            {enumHelper.convertEnumValueToTitle(
                              ENUMS.TABLE_FLOORS.list,
                              table.floor,
                            )}
                          </td>
                          <td className='text-center'>
                            {enumHelper.convertEnumValueToTitle(
                              ENUMS.TABLE_LOCATIONS.list,
                              table.location,
                            )}
                          </td>
                          <td className='text-center'>{table.totalChairs}</td>
                          <td className='text-center'>
                            <i
                              className={
                                table.allowSmoking
                                  ? 'fal fa-check-circle text-success'
                                  : 'fal fa-times-circle text-danger'
                              }
                            />
                          </td>
                          <td className='text-center'>
                            <i
                              className={`${table.haveHeatSystem
                                ? 'fal fa-check-circle text-success'
                                : 'fal fa-times-circle text-danger'
                                }`}
                            />
                          </td>
                          <td className='text-center'>
                            <i
                              className={`${table.hasCoolingSystem
                                ? 'fal fa-check-circle text-success'
                                : 'fal fa-times-circle text-danger'
                                }`}
                            />
                          </td>
                          <td className='text-center'>
                            <i
                              className={`${table.hasFogSpray
                                ? 'fal fa-check-circle text-success'
                                : 'fal fa-times-circle text-danger'
                                }`}
                            />
                          </td>
                          {table.inputAmount > 0 ? (
                            <td className={'text-center '}>
                              {parseInt(table.inputAmount).toLocaleString()}
                            </td>
                          ) : (
                            <td className={'text-center '}></td>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <div className='my-3'>
                <label htmlFor='amenity' className='rsee-form-label pl-3'>
                  {locales('messages.facilities')}
                </label>
                <span
                  name='amenity'
                  id='amenity'
                  className='text-dark font-weigth-bold font-large my-2'
                >
                  {amenities && amenities.length
                    ? amenities.map((amenity, index, self) => (
                      <span className='mx-2' key={index}>
                        {amenity.name} {index < self.length - 1 ? '،' : ''}
                      </span>
                    ))
                    : '---'}
                </span>
              </div>
            </div>

            <div className='my-3'>
              <label
                htmlFor='meals'
                className='rsee-form-label meal-label-width'
              >
                {locales('fields.day.meals')}
              </label>
              <span
                name='meals'
                id='meals'
                className='text-dark font-weigth-bold font-large my-2'
              >
                {meals && meals.length
                  ? meals.map((meal, index, self) => (
                    <span className='mx-2' key={index}>
                      {enumHelper.convertEnumValueToTitle(
                        ENUMS.MEAL_PORTIONS.list,
                        meal,
                      )}
                      {index < self.length - 1 ? '،' : ''}
                    </span>
                  ))
                  : '---'}
              </span>
            </div>

            <div className='my-3'>
              <label
                htmlFor='prePaid'
                className='rsee-form-label prePaid-label-width'
              >
                {locales('titles.prePayForEachPersonPerHour')}
              </label>
              <span
                name='prePaid'
                id='prePaid'
                className='text-dark font-weigth-bold font-large'
              >
                {`${formatter.numberWithCommas(
                  manHourPrepaidPrice,
                )} ${enumHelper.convertEnumValueToTitle(
                  ENUMS.CURRENCY.list,
                  currency,
                )}` || '---'}
              </span>
            </div>

            <div className='d-flex justify-content-between flex-wrap border-top py-3'>
              <div className='d-flex justify-content-between col-12'>
                <label htmlFor='cafeImages' className='rsee-form-label'>
                  {locales('titles.cafeLogo')}
                </label>
                <ShowForPermission
                  permission={ENUMS.PERMISSIONS.values.EDIT_CAFE_FOR_CAFE_ADMIN}
                >
                  <NavLink
                    to={{
                      pathname: '/my-cafe-info/edit-cafe-images',
                      locationTableUrl,
                      logoUrl,
                      cafeImages,
                    }}
                  >
                    <button className='btn btn-primary'>
                      {locales('titles.editCafeLogo')}
                    </button>
                  </NavLink>
                </ShowForPermission>
              </div>
              <span
                name='cafeLogo'
                id='cafeLogo'
                className='text-dark font-weigth-bold font-large my-2 upload-cafe-logo'
              >
                <img className='mx-2 w-100 h-100' src={`${logoUrl}`} />
              </span>
            </div>

            <div className='d-flex justify-content-between flex-wrap border-top py-3'>
              <div className='d-flex justify-content-between col-12'>
                <label htmlFor='cafeImages' className='rsee-form-label'>
                  {locales('titles.cafe.images')}
                </label>
                <ShowForPermission
                  permission={ENUMS.PERMISSIONS.values.EDIT_CAFE_FOR_CAFE_ADMIN}
                >
                  <NavLink
                    to={{
                      pathname: '/my-cafe-info/edit-cafe-images',
                      locationTableUrl,
                      logoUrl,
                      cafeImages,
                    }}
                  >
                    <button className='btn btn-primary'>
                      {locales('titles.editCafePhotos')}
                    </button>
                  </NavLink>
                </ShowForPermission>
              </div>
              <span
                name='cafeImages'
                id='cafeImages'
                className='text-dark font-weigth-bold font-large my-2 d-flex'
              >
                {cafeImages &&
                  cafeImages.length &&
                  cafeImages.map((cafeImage, index) => (
                    <div className='upload-cafe-images'>
                      <img
                        className='mx-2 w-100 h-100'
                        key={index}
                        src={`${ASSET_ENDPOINT}${cafeImage.url}`}
                      />
                    </div>
                  ))}
              </span>
            </div>

            <div className='d-flex justify-content-between flex-wrap border-top py-3'>
              <div className='d-flex justify-content-between col-12'>
                <label htmlFor='cafeImages' className='rsee-form-label'>
                  {locales('fields.table.location.image')}
                </label>
                <ShowForPermission
                  permission={ENUMS.PERMISSIONS.values.EDIT_CAFE_FOR_CAFE_ADMIN}
                >
                  <NavLink
                    to={{
                      pathname: '/my-cafe-info/edit-cafe-images',
                      locationTableUrl,
                      logoUrl,
                      cafeImages,
                    }}
                  >
                    <button className='btn btn-primary'>
                      {locales('titles.editLocationTableImage')}
                    </button>
                  </NavLink>
                </ShowForPermission>
              </div>
              <span
                name='cafeTableLocation'
                id='cafeTableLocation'
                className='text-dark font-weigth-bold font-large my-2 '
              >
                {locationTableUrl !== '' &&
                  locationTableUrl?.slice(-3) === 'pdf' ? (
                  <a
                    href={locationTableUrl}
                    target='_blank'
                    className='mx-2 pdf-view'
                  >
                    <img src={pdfIcon} className='img-thumb' />
                  </a>
                ) : (
                  locationTableUrl !== '' && (
                    <img
                      className='mx-2 w-100 h-100'
                      src={`${locationTableUrl}`}
                    />
                  )
                )}
              </span>
            </div>
          </div>
        </section>
      </Spin>
    </Fragment>
  );
};

const mapStateToProps = state => {
  return {
    cafeByIdForAdminLoading: state.cafesReducer.cafeByIdForAdminLoading,
    cafeByIdForAdminFailed: state.cafesReducer.cafeByIdForAdminFailed,
    cafeByIdForAdminError: state.cafesReducer.cafeByIdForAdminError,
    cafeByIdForAdminMessage: state.cafesReducer.cafeByIdForAdminMessage,
    cafeByIdForAdmin: state.cafesReducer.cafeByIdForAdmin,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCafeByIdForAdmin: () => dispatch(cafeActions.getCafeByIdForAdmin()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyCafeInfo),
);
